import React, { useEffect } from 'react';
import { bool, func } from 'prop-types';
import { compose } from 'recompose';
import { connect } from 'react-redux';

import * as ReportsConstants from '../../../../constants/reports';
import * as ChartsConstants from '../../../../constants/charts';
import {
  fetchApisWithRLQ,
  fetchApiPerOrgList,
  fetchOrgList,
  fetchMetricsData,
  setChartParams,
} from '../../../../actions/metrics';
import { setUserMetricFilter, setUserDateFilter } from '../../../../actions/filterState';
import { getUserDetails } from '../../../../reducers/portalConfig';
import { getApisWithRLQList, getOrgMap, getApiPerOrgList } from '../../../../reducers/metrics';
import { getMetricsFiltersState, getDateFilterState } from '../../../../reducers/filterState';

import UsageReport from '../../../../components/Analytics/UsageReport';

import DailyQuotaChart from '../../CannedCharts/UsageCharts/DailyQuotaChart';
import MonthlyQuotaChart from '../../CannedCharts/UsageCharts/MonthlyQuotaChart';
import HourlyQuotaChart from '../../CannedCharts/UsageCharts/HourlyQuotaChart';

const reportProps = {
  type: ReportsConstants.REPORT_QUOTA,
  charts: [
    {
      component: MonthlyQuotaChart,
      id: ChartsConstants.CHART_QUOTA_MONTHLY,
    },
    {
      component: DailyQuotaChart,
      id: ChartsConstants.CHART_QUOTA_DAILY,
    },
    {
      component: HourlyQuotaChart,
      id: ChartsConstants.CHART_QUOTA_HOURLY,
    },
  ],
};

const reportId = ReportsConstants.REPORT_QUOTA_SAVE;

const mapDispatchToProps = (dispatch) => ({
  fetchApiList: () => dispatch(fetchApisWithRLQ()),
  fetchApiPerOrgList: () => dispatch(fetchApiPerOrgList()),
  fetchOrgList: () => dispatch(fetchOrgList()),
  fetchMetricsData: (chartID, params, path,
    aggregation, entityType) =>
    dispatch(fetchMetricsData(chartID, params, path, aggregation, entityType)),
  setUserDateFilter: (userId, orgUuid, filterType, value) =>
    dispatch(setUserDateFilter(userId, reportId, orgUuid, filterType, value)),
  setUserMetricFilter: (userId, orgUuid,
    filterType, value) =>
    dispatch(setUserMetricFilter(userId, reportId, orgUuid, filterType, value)),
  setChartParams: (chartID, params) =>
    dispatch(setChartParams(chartID, params)),
});

const mapStateToProps = (state) => {
  const userObj = getUserDetails(state) || {};
  const userId = userObj && userObj.uuid;
  const orgUuid = userObj.organizationUuid || '';
  const isDeveloper = userObj.developer;
  const isOrgAdmin = userObj.orgAdmin;
  const isOrgPublisher = userObj.orgPublisher;
  return {
    userId,
    orgUuid,
    isDeveloper,
    isOrgAdmin,
    isOrgPublisher,
    apiMap: getApisWithRLQList(state),
    apiPerOrgList: getApiPerOrgList(state),
    orgMap: getOrgMap(state),
    selectedDate: getDateFilterState(state, userId, reportId, orgUuid),
    selectedMetrics: getMetricsFiltersState(state, userId, reportId, orgUuid),
  };
};

const UsageReportPage = (props) => {
  const {
    fetchApiList,
    fetchApiPerOrgList,
    fetchOrgList,
    isDeveloper,
    isOrgAdmin,
    isOrgPublisher,
  } = props;

  useEffect(() => {
    if (!isDeveloper && !isOrgAdmin && !isOrgPublisher) {
      fetchOrgList();
    }
    fetchApiList();
    fetchApiPerOrgList();
  }, []);

  return (<UsageReport
    {...props}
    charts={reportProps.charts}
    type={reportProps.type}
  />);
};

UsageReportPage.propTypes = {
  fetchApiList: func,
  fetchApiPerOrgList: func,
  fetchOrgList: func,
  isDeveloper: bool,
  isOrgAdmin: bool,
  isOrgPublisher: bool,
};

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
)(UsageReportPage);
